
import React from "react";
import PropTypes from "prop-types";
import Dialog from "material-ui/Dialog";
import IconButton from "material-ui/IconButton";

import FlatButton from "material-ui/FlatButton";


/**
 * Alerts are urgent interruptions, requiring acknowledgement, that inform the user about a situation.
 */
export default class DialogAlert extends React.Component {
  state = {
    open: true,
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.onClose();
  };

  render() {
    const actions = [
      <FlatButton
        label="Aceptar"
        primary
        onClick={this.handleClose}
      />,
    ];

    return (
      <div>

        <Dialog
          title={
            <div>
              <div style={{ float: "right" }}>
                <IconButton onClick={this.handleClose} >
                  <i className="material-icons" style={{ color: "#ffffff" }}>close</i>
                </IconButton>
              </div>
            </div>
          }
          actions={actions}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
        >
          {this.props.message}
        </Dialog>
      </div>
    );
  }
}

DialogAlert.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};




// WEBPACK FOOTER //
// ./src/componentsGlobal/DialogAlert.jsx